// extracted by mini-css-extract-plugin
export default {"row":"TRpyOXXHSwhUva_nqXRo","colTxt":"xzJ_gc0rRmIB2cJFzu86","title":"I4DyXb9p1Hu4vUyBEqhC","body":"PIQpAobYWxnP4lVAk07p","colImg":"gVEA_ojTAa334745lNMP"};